'use strict';
module.exports = require('../../full/instance/slice');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/slice.js
// module id = 600
// module chunks = 13